import { createSlice } from "@reduxjs/toolkit";

type ICurrentUser = {
  Id: number;
  User: {
    Title: string;
    ID: number;
    UserName: string;
  };
  Manager: {
    Title: string;
    ID: number;
    UserName: string;
    Email:string;
  };
  ID: number;
  Role: string;
  Created: string;
  GUID: string;
  Settings: any;
  LastSeenDate:any;
};
const initialState = {
  Users: [],
  currentUser: {} as ICurrentUser,
  Role: "",
  userKey: 1,
  licenceKey:"",
  active: null,
};
const slice = createSlice({
  name: "userValues",
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.Users = action.payload;
    },
    setRole: (state, action) => {
      state.Role = action.payload;
    },
    changeKey: (state) => {
      state.userKey = state.userKey + 1;
    },
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    },
    updateLicenceKey:(state,action) => {
      state.licenceKey = action.payload
    },
    setActive:(state,action)=>{
      state.active=action.payload
  }
  },
});
export const {
  setUsers,
  setRole,
  changeKey,
  setCurrentUser,
  updateLicenceKey,
  setActive
} = slice.actions;
export default slice.reducer;
